interface IBankConnectionsIconProps {
  className?: string;
}

/**
 * Stylized building + plug — a bank facade (columns + pediment) wired up via
 * a horizontal "connection" line ending in a plug. Reads as "an account
 * connected to the bank": classic bank glyph + the connection metaphor that
 * differentiates this tool from generic bank/account icons. Monoline,
 * `currentColor`, no fills. Designed on a 48×48 grid.
 */
const BankConnectionsIcon = ({ className }: IBankConnectionsIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* pediment */}
    <path d="M8 14 L20 6 L32 14" />
    {/* base */}
    <path d="M5 38 H35" strokeLinecap="square" />
    {/* columns */}
    <path d="M10 16 V36" />
    <path d="M16 16 V36" />
    <path d="M24 16 V36" />
    <path d="M30 16 V36" />
    {/* connection line */}
    <path d="M32 24 H40" strokeLinecap="square" />
    {/* plug head */}
    <path d="M40 21 V27" />
    <path d="M43 22 V26" />
  </svg>
);

export default BankConnectionsIcon;
